var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-title flex flex-align-center",style:(_vm.imageCssVars)},[_c('div',{staticClass:"logo-wrapper"},[(_vm.icon)?_c('SBIcon',{attrs:{"icon":_vm.icon,"color":_vm.iconColor,"size":26}}):_c('div',{staticClass:"image-wrapper"})],1),_vm._v("\n  "+_vm._s(_vm.title)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }